// extracted by mini-css-extract-plugin
export default {"spinner":"IosSpinner_spinner__kdpal","spinnerSpoke":"IosSpinner_spinnerSpoke__Njni-","spokeFade":"IosSpinner_spokeFade__cPQHY"};